// extracted by mini-css-extract-plugin
module.exports = {"container":"QuickFilters_container__Oqloe","quickFilter":"QuickFilters_quickFilter__7l_HP"};